import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  ViewChild,
  inject
} from '@angular/core';

import { Subscription } from 'rxjs';

import { MetaNavItem } from '@hdms/shared/page-frame/types';
import { FlyoutDirective } from '@hdms/shared/ui-core';
import { AnalyticsService } from '@hdms/shared/util-core';

import { TrackingValue } from '../../../config/header.const';
import { MenuStateService } from '../../../services';

@Component({
  selector: 'shrd-pf-ft-meta-popover',
  templateUrl: './header-meta-popover.component.html',
  styleUrls: ['./header-meta-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderMetaPopoverComponent implements AfterContentInit, OnDestroy {
  isOpen: boolean;

  @Input() navItem: MetaNavItem;
  @Input() flyoutClass: string;
  @Input() buttonCustomMaxWidth: string;
  @Input() qaId: string;

  @ViewChild(FlyoutDirective) private readonly flyout: FlyoutDirective;

  private closeSubscription: Subscription;
  private readonly stateService = inject(MenuStateService);
  private readonly analyticsService = inject(AnalyticsService);

  onVisibilityChange(isOpen: boolean): void {
    this.isOpen = isOpen;
    this.isOpen &&
      this.analyticsService.sendEvent({
        category: TrackingValue.SITE_OPERATIONS,
        action: TrackingValue.MAIN_NAVIGATION,
        label: this.navItem.trackingName
      });
  }

  ngAfterContentInit(): void {
    this.closeSubscription = this.stateService.close$.subscribe(_ => this.flyout.close());
  }

  ngOnDestroy(): void {
    this.closeSubscription?.unsubscribe();
  }
}
